import { useState } from "react";
import useFormat from "@/hooks/useFormat";

/**
 * A CDN-resized artwork with its `original` as the fallback (SHO-757): a
 * variant the CDN still fails to produce (cold, see the home) gives way to
 * the original on `onError` — heavier, never a broken image. Spread the
 * result on a `FadeInImage`.
 */
export default function useResizedArtwork(original: string, height: string) {
  const { getResizedThumbnailUrl } = useFormat();
  const [variantFailed, setVariantFailed] = useState(false);

  return {
    src: variantFailed ? original : getResizedThumbnailUrl(original, height),
    onError: () => setVariantFailed(true),
  };
}
